module.exports = __webpack_public_path__ + "img/plus-sign-stroke-white.4950d60d.svg";